import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StaticService {

  constructor() { }

  public get skipSpecificURL(){
    return ['hgh'];
  }

  public get skipToggleAndSideMenu(){
    return ['DIGITAL_CATALOUGE','/analytics/applicationHits/save'];
  }
}
